
import React from 'react';
import { Box, Card, Divider } from '@mui/material';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect, useRef } from 'react';
import FormControl from '@mui/material/FormControl';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { useTranslation } from "react-i18next";


export default function SubscriptionFee() {
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };



    const [Dis, setDis] = useState(false);
    const [spinner, setSpinner] = React.useState(false);
    const [isActive, setisActive] = useState(false);
    const [Fee, setFee] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        GetMembershipFeeDetails();
    }, []);

    const GetMembershipFeeDetails = async () => {
        setSpinner(true);
        axios.get("SystemUser/GetMembershipFee")
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    if (res?.data?.data == null) {
                        setisActive(false);
                        setFee('');
                    } else {
                        setFee(res?.data?.data?.membershipFee);
                        setisActive(res?.data?.data?.isActive);
                    }
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                }
            }).catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setSpinner(false);
            });
    }

    const SaveMembershipFee = async () => {
        setSpinner(true);
        setDis(true);
        if (Fee != "") {
            const data = {
                "membershipFee": Fee,
                "isActive": isActive == "true" ? true : false
            }
            axios.post("SystemUser/PostMembershipFee", data)
                .then((res) => {
                    if (res?.data?.responseCode == 100) {
                        GetMembershipFeeDetails();
                        toastNotify(res?.data?.responseMessage, true);
                    } else {
                        toastNotify(res?.data?.responseMessage, false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setSpinner(false);
                    setDis(false);
                });
        } else {
            toastNotify("Please enter mandatory fields", false);
            setDis(false);
            setSpinner(false);
        }
    }

    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Card>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <h3>Subscription Fee Configuration</h3>
                    </div>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <Box >
                    <div className='mx-4'>
                        <span style={{ color: "#3E4A62" }}>Subscription Fee:  <span style={{ color: "red" }}>*</span></span>
                        <TextField
                            className='mx-5'
                            size='small'
                            sx={{ width: "320px" }}
                            value={Fee}
                            InputProps={{ inputProps: { min: "0" } }}
                            type='number'

                            onChange={(e) => {
                                const val = e?.target?.value;
                                if (val >= 0) {
                                    setFee(val);
                                } else {
                                    setFee(0);
                                }
                            }} />
                    </div>
                    <div className='mx-4 mt-3 '>
                        <span style={{ color: "#3E4A62" }}>Is Active:  <span style={{ color: "red" }}>*</span></span>
                        <FormControl>
                            <RadioGroup
                                sx={{ paddingLeft: "120px" }}
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                                value={isActive}
                                onClick={(e) => setisActive(e?.target?.value)}
                            >
                                <Stack direction={"row"} spacing={5}>
                                    <FormControlLabel value={true} control={<Radio />} label="Yes" />
                                    <FormControlLabel value={false} control={<Radio />} label="No" />
                                </Stack>

                            </RadioGroup>
                        </FormControl>
                    </div>

                    <div className='mx-4 mt-3 mb-3 text-right'>
                        <Button variant="contained" sx={{ padding: "15px" }} disabled={Dis} onClick={SaveMembershipFee}> Save </Button>
                    </div>


                </Box >

            </Card>

        </>
    )
}


